import React, { Component } from 'react'
import './Menu.css' 

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from '../lib/BodyScrollLock';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import Res from '../values/Resources'

import MenuButton from './MenuButton'


import FontAwesomeIcon from '@fortawesome/react-fontawesome'

export default class Menu extends Component {

	componentDidMount() {
		//disableBodyScroll(this.menu)
		//enableBodyScroll(this.menu)
		this.targetElement = document.querySelector('#menu')
	}

	componentWillReceiveProps(nextProps) {
		//return
		if(this.menu && nextProps.visible !== this.props.visible) {
			if(nextProps.visible) {
				setTimeout(() => {
					disableBodyScroll(this.targetElement)
					//document.body.style.overflow = 'hidden';
    				//document.documentElement.style.overflow = 'hidden';
				}, 250)
    			
				
			}
			else {
				enableBodyScroll(this.targetElement)
				//return
				//document.body.style.overflow = 'visible';
    			//document.documentElement.style.overflow = 'visible';
    			setTimeout(() => {
    				console.log('scrolling to ' + nextProps.scrollTop)
    				window.scrollTo(0, nextProps.scrollTop)
    			})
				
			}
		}
	}

	componentWillUnmount() {
		//return
		clearAllBodyScrollLocks()
	}

	render() {

		//console.log('render')

		let { visible, language, buttonVisible, buttonWhite, buttonActive, onButtonClick } = this.props

		let container = 'container',
			menuClass = 'menu',
			background = 'menuBackground', 
			frag1 = 'fragment f1', 
			frag2 = 'fragment f2', 
			frag3 = 'fragment f3', 
			frag4 = 'fragment f4',
			menuContent = 'menuContent',
			en = '',
			br = ''

		if(language === 'br')
			br = 'selected'
		else
			en = 'selected'

		if(visible) {
			container += ''
			menuClass += ' visible'
			background += ' visible'
			frag1 += ' visible'
			frag2 += ' visible'
			frag3 += ' visible'
			frag4 += ' visible'
			menuContent += ' visible'
		} 

		/*
		<h1>{Res.strings.menu_contact_cel}</h1>

		<FontAwesomeIcon id='icon' icon={['fab', 'facebook-f']} className='socialBtn'/>
		<FontAwesomeIcon id='icon' icon={['fab', 'twitter']} className='socialBtn'/>
		*/
		return (
			<div className={container}>
				<div className='children'>
					{this.props.children}
					
				</div>

				

				<MenuButton
				  whiteBg={buttonWhite || true}
				  visible={buttonVisible}
				  active={buttonActive}
				  onMenuBtnClick={onButtonClick}/>

				<div className={menuContent + ' languageSelector'}>
					<div onClick={() => this.props.onLanguageSelected('en')}><h1 className={en}>EN</h1></div>
					<div onClick={() => this.props.onLanguageSelected('br')}><h1 className={br}>BR</h1></div>
				</div>
				<div className={menuContent + ' infoContainer'}>
					<h1>{Res.strings.menu_info_name}</h1>
					<h2>{Res.strings.menu_info_details}</h2>
				</div>
				<div className={menuContent + ' socialButtons'}>
					<a href={Res.strings.instagram_link} target='_blank'>
						<FontAwesomeIcon id='icon' icon={['fab', 'instagram']} className='socialBtn'/>
					</a>
					<a href={Res.strings.medium_link} target='_blank'>
						<FontAwesomeIcon id='icon' icon={['fab', 'medium-m']} className='socialBtn'/>
					</a>
					<a href={Res.strings.messenger_link} target='_blank'>
						<FontAwesomeIcon id='icon' icon={['fab', 'facebook-messenger']} className='socialBtn'/>
					</a>
					<a href={Res.strings.whatsapp_link} target='_blank'>
						<FontAwesomeIcon id='icon' icon={['fab', 'whatsapp']} className='socialBtn'/>
					</a>					
				</div>
				<div className={menuContent + ' contactInfo'}>
					<h1>{Res.strings.menu_contact_email}</h1>
				</div>

				<div className={menuContent}>
					
					
				</div>

				<div className={frag1}/>
					<div className={frag2}/>
					<div className={frag3}/>
					<div className={frag4}/>

					<div className={background}/>

				<div id='menu' ref={(ref) => this.menu = ref} className={menuClass}>
				
				</div>
			</div>
		)

		return (
			<div ref={(ref) => this.menu = ref} className={menuClass}>
				<div className={background}/>
				<div className={frag1}/>
				<div className={frag2}/>
				<div className={frag3}/>
				<div className={frag4}/>

				<div className={menuContent}>
					<div className='languageSelector'>
						<div onClick={() => this.props.onLanguageSelected('en')}><h1 className={en}>EN</h1></div>
						<div onClick={() => this.props.onLanguageSelected('br')}><h1 className={br}>BR</h1></div>
					</div>
					<div className='infoContainer'>
						<h1>{Res.strings.menu_info_name}</h1>
						<h2>{Res.strings.menu_info_details}</h2>
					</div>
					<div className='socialButtons'>
						<a href={Res.strings.instagram_link} target='_blank'>
							<FontAwesomeIcon id='icon' icon={['fab', 'instagram']} className='socialBtn'/>
						</a>
						<a href={Res.strings.medium_link} target='_blank'>
							<FontAwesomeIcon id='icon' icon={['fab', 'medium-m']} className='socialBtn'/>
						</a>
						<a href={Res.strings.messenger_link} target='_blank'>
							<FontAwesomeIcon id='icon' icon={['fab', 'facebook-messenger']} className='socialBtn'/>
						</a>
						<a href={Res.strings.whatsapp_link} target='_blank'>
							<FontAwesomeIcon id='icon' icon={['fab', 'whatsapp']} className='socialBtn'/>
						</a>					
					</div>
					<div className='contactInfo'>
						<h1>{Res.strings.menu_contact_email}</h1>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Menu.js